import { c as _c } from "react/compiler-runtime";
import Logo from "assets/svg/logo.svg";
import type React from "react";
import { cn } from "@/lib/utils";
interface IProps {
  loading?: boolean;
  tips?: string;
  className?: string;
  style?: React.CSSProperties;
  fullScreen?: boolean;
  [key: string]: any;
}
export const PopLoading = props => {
  const $ = _c(7);
  const {
    loading: t0,
    className: t1,
    fullScreen: t2,
    style: t3
  } = props;
  const loading = t0 === undefined ? true : t0;
  const className = t1 === undefined ? "" : t1;
  const fullScreen = t2 === undefined ? false : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const style = t4;
  let t5;
  if ($[2] !== className || $[3] !== fullScreen || $[4] !== loading || $[5] !== style) {
    t5 = fullScreen ? <>{loading && <div className={cn("fixed left-0 top-0 z-[9999] flex h-screen w-screen items-center justify-center bg-white", className)} style={{
        ...style
      }}><div className="aspect-160/48 relative h-6 overflow-hidden bg-gray-300 md:h-10"><div className="bg-destructive absolute   inset-0" style={{
            animation: "loadingProgress 2s ease-in-out infinite",
            width: "0%"
          }} /><Logo className="absolute left-1/2 top-1/2 h-[70.83%] w-[90%] -translate-x-1/2 -translate-y-1/2 " /></div></div>}<style jsx={true}>{"\n        @keyframes loadingProgress {\n          from {\n            width: 0%;\n          }\n          to {\n            width: 100%;\n          }\n        }\n      "}</style></> : <div className="flex items-center justify-center" style={{
      ...style
    }}><div className={cn("inline-block h-4 w-4 animate-spin rounded-full border-2 border-gray-100 border-t-black md:h-7 md:w-7", className)} /></div>;
    $[2] = className;
    $[3] = fullScreen;
    $[4] = loading;
    $[5] = style;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};